export default __webpack_public_path__ + "static/media/yelpcampclone.6dc32aa5.png";